import script from "./MStepperV2.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20Step"
export * from "./MStepperV2.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20Step"

import "./MStepperV2.vue?vue&type=style&index=0&id=12f71f5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12f71f5c"]])

export default __exports__